 import React, { useEffect, useState } from 'react'
import SideBar from '../Sidebar/SideBar';
import { Icon } from '@iconify/react/dist/iconify.js';
import PackageDetail from '../../Api/PackageDetails';
import Package from '../../Api/Package';
import FormDetailsApi from '../../Api/FormDetailsApi';
import SearchableDropdown from './SearchableDropdown';
import Swal from "sweetalert2";


const PackageDetails = () => {

    const [itemId, setitemId] = useState('');
    const [inputs, setInputs] = useState({
        formId: '',
        packagesId: ''
    });
    const [packageOptions, setPackageOptions] = useState([]);
    const [formOptions, setFormOptions] = useState([]);

    const [data1, setData1] = useState([]);
    useEffect(() => {
        console.log("inputs", inputs);
    }, [inputs]);

    const handleChange = (e) => {
        const { name, value } = e.target;
        setInputs((prevData) => ({
            ...prevData,
            [name]: value,
        }));
    };

    const handleSave = async () => {
        if (!inputs.packagesId || !inputs.formId) {
            await Swal.fire({
                title: "Validation",
                text: "Package and Form are required.",
                icon: "warning",
                width: "300px",
            });
            return;
        }

        const response = await PackageDetail.CreatePackage(inputs)
        if (response?.StatusCode === 201) {
            console.log("response", response);
            await Swal.fire({
                title: "Saved",
                text: "Package details created successfully.",
                icon: "success",
                width: "300px",
            });
            setInputs({
                formId: '',
                packagesId: ''
            });
            fetchData()
        } else {
            await Swal.fire({
                title: "Error",
                text: response?.ErrorMessages || "Unable to create package detail.",
                icon: "error",
                width: "300px",
            });
        }
    }

    const handleUpdate = async () => {
        if (!inputs.packagesId || !inputs.formId) {
            await Swal.fire({
                title: "Validation",
                text: "Package and Form are required.",
                icon: "warning",
                width: "300px",
            });
            return;
        }

        const response = await PackageDetail.UpdatePackageById(itemId, inputs)
        if (response?.StatusCode === 200) {
            await Swal.fire({
                title: "Updated",
                text: "Package details updated successfully.",
                icon: "success",
                width: "300px",
            });
            console.log("response", response);
            setInputs({
                formId: '',
                packagesId: ''
            })
            setitemId('')
            fetchData()
        } else {
            await Swal.fire({
                title: "Error",
                text: response?.ErrorMessages || "Unable to update package detail.",
                icon: "error",
                width: "300px",
            });
        }
    }


    const handleEdit = (item) => {
        console.log("item", item);
        setitemId(item.id);
        setInputs({
            formId: item.formId,
            packagesId: item.packagesId,
        })
        console.log(`Edit item with id ${item.id}`);
    };

    const handleDelete = async (id) => {
        const confirmResult = await Swal.fire({
            title: "Are you sure?",
            text: "Are you sure you want to delete this package detail?",
            showCancelButton: true,
            confirmButtonColor: "#d33",
            cancelButtonColor: "#3085d6",
            confirmButtonText: "Yes delete it !!",
            width: "300px",
        });

        if (!confirmResult.isConfirmed) return;

        const response = await PackageDetail.DeletePackageById(id);
        if (response.StatusCode === 200) {
            await Swal.fire({
                title: "Deleted",
                text: "Package detail deleted successfully.",
                icon: "success",
                width: "300px",
            });
            fetchData()
        } else {
            await Swal.fire({
                title: "Error",
                text: response?.ErrorMessages || "Unable to delete package detail.",
                icon: "error",
                width: "300px",
            });
        }
        // setData1(data1.filter(item => item.id !== id));
    };

    /******************************************************* */

    const [data, setData] = useState([
        { id: 1, sno: '1', name: 'Optical Branch 1' },
        { id: 2, sno: '2', name: 'Restaurant Branch 1' },
        { id: 3, sno: '3', name: 'Optical Branch 2' },
        { id: 4, sno: '4', name: 'Restaurant Branch 2' },
    ]);

    const [searchQuery, setSearchQuery] = useState('');
    const [filteredData, setFilteredData] = useState([]);
    const [transferredItems, setTransferredItems] = useState([]);

    // Handler for search input change
    const handleSearchChange = (event) => {
        setSearchQuery(event.target.value);
    };

    // Handler for search button click
    const handleSearchClick = () => {
        // Filter the data based on the search query
        const results = data.filter(item =>
            item.name.toLowerCase().includes(searchQuery.toLowerCase())
        );

        // Append the new results to the existing filtered data without duplicates
        setFilteredData(prevFilteredData => {
            const newFilteredData = [...prevFilteredData];
            results.forEach(item => {
                if (!newFilteredData.some(existingItem => existingItem.id === item.id)) {
                    newFilteredData.push(item);
                }
            });
            return newFilteredData;
        });
    };

    // Handler for row click to transfer item details to the second table
    const handleRowClick = (item) => {
        // Remove the clicked item from the filtered data
        setFilteredData(prevFilteredData =>
            prevFilteredData.filter(existingItem => existingItem.id !== item.id)
        );

        // Add the clicked item to the transferred items list
        setTransferredItems(prevTransferredItems => [
            ...prevTransferredItems,
            item
        ]);
    };

    // Handler to delete an item from the transferred items list
    const handleDeleteTab = (id) => {
        setTransferredItems(prevTransferredItems =>
            prevTransferredItems.filter(item => item.id !== id)
        );
    };


    const getSerialNumber = (index) => index + 1;


    const fetchData = async () => {
        const response = await PackageDetail.GetAllPackage()
        if (response) {
            console.log("response", response);
            setData1(response.Result)
        }
    }

    const fetchDropdownData = async () => {
        const [packagesResponse, formsResponse] = await Promise.all([
            Package.GetAllPackage(),
            FormDetailsApi.GetAllFormDetails(),
        ]);

        if (packagesResponse?.Result) {
            setPackageOptions(packagesResponse.Result);
        }

        if (formsResponse?.Result) {
            setFormOptions(formsResponse.Result);
        }
    };

    const getPackageName = (id) => {
        const pkg = packageOptions.find((item) => String(item.id) === String(id));
        return pkg ? pkg.name : id;
    };

    const getFormName = (id) => {
        const form = formOptions.find((item) => String(item.Id) === String(id));
        return form ? form.FormName : id;
    };

    useEffect(() => {
        fetchData();
        fetchDropdownData();
    }, []);




    return (
        <div className='Flex-general-client-sidebar'>
            <div className='sidebar-gen-width'>
                <SideBar />
            </div>
            <div className='Main-general-Client'>
                <div className='header-general'>
                    <h2 className='general-card-title'>Package Details</h2>
                </div>
                <div className="control_radius">
                    {/* <div className="company_info-text-im depart_top">Report Template Setting</div> */}
                    <div className="company_control">
                        <div className="stock-im-dep1">
                            <div className="input-box-Imo1">
                                <div className="input-box-mok1">
                                    <SearchableDropdown
                                        options={packageOptions}
                                        value={inputs.packagesId}
                                        onChange={(id) => setInputs({ ...inputs, packagesId: id })}
                                        labelField="name"
                                        valueField="id"
                                        placeholder="Select Package"
                                        required
                                    />
                                </div>
                            </div>
                        </div>
                        <div className="stock-im-dep1">
                            <div className="input-box-Imo1 input-height2">
                                <div className="input-box-mok1">
                                    <SearchableDropdown
                                        options={formOptions}
                                        value={inputs.formId}
                                        onChange={(id) => setInputs({ ...inputs, formId: id })}
                                        labelField="FormName"
                                        valueField="Id"
                                        placeholder="Select Form"
                                        required
                                    />
                                </div>
                            </div>
                        </div>
                    </div>
                    {/* <div className="company_control">
                        <div className="stock-im-dep1">
                            <div className="input-box-Imo1 input-height2">
                                <div className="input-box-mok1">
                                    <input className="modify_im_input mode_category1"
                                        type="text" name="" required />
                                    <label class="modify_p_text2">Form Id</label>
                                </div>
                            </div>
                        </div>
                        <div className="stock-im-dep1">
                            <div className="input-box-Imo1 input-height2">
                                <div className="input-box-mok1">
                                    <input className="modify_im_input mode_category1"
                                        type="date" name="" required />
                                    <label class="modify_lbl_text3">Credit Date</label>
                                </div>
                            </div>
                        </div>
                    </div> */}
                    <div className="">
                        <div className="stock-im-dep1">
                            <div className="input-box-Imo1 input-height2">
                                <div className="input-box-mok1 flex-search-btn">
                                    <input
                                        type="text"
                                        className="modify_im_input mode_category1"
                                        placeholder="Search..."
                                        value={searchQuery}
                                        onChange={handleSearchChange}
                                    />
                                    <button className="search-button-main" onClick={handleSearchClick}>Search</button>
                                    <label className="modify_lbl_text3">Search</label>
                                </div>
                            </div>
                        </div>

                        <div className="company_control">
                            <div className="table-search-menu">
                                <table className="data-table">
                                    <thead className='header-table-search'>
                                        <tr>
                                            <th className='table-header-manager ac-sno-wth'>SNo</th>
                                            <th className='table-header-manager'>ID</th>
                                            <th className='table-header-manager'>Name</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {filteredData.length > 0 ? (
                                            filteredData.map((item, index) => (
                                                <tr
                                                    key={item.id}
                                                    onClick={() => handleRowClick(item)}
                                                >
                                                    <td className='table-data-account ac-sno-wth first-tab-padd'>{getSerialNumber(index)}</td>
                                                    <td className='table-data-account first-tab-padd'>{item.id}</td>
                                                    <td className='table-data-account first-tab-padd'>{item.name}</td>
                                                </tr>
                                            ))
                                        ) : (
                                            <tr>
                                                <td colSpan="3">No results found</td>
                                            </tr>
                                        )}
                                    </tbody>
                                </table>
                            </div>

                            {transferredItems.length > 0 && (
                                <div className="table-search-menu">
                                    <table className="data-table">
                                        <thead className='header-table-search'>
                                            <tr>
                                                <th className='table-header-manager'>SNo</th>
                                                <th className='table-header-manager'>ID</th>
                                                <th className='table-header-manager'>Name</th>
                                                <th className='table-header-manager'>Action</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {transferredItems.map((item, index) => (
                                                <tr key={item.id}>
                                                    <td className='table-data-account bg-other-table'>{getSerialNumber(index)}</td>
                                                    <td className='table-data-account bg-other-table'>{item.id}</td>
                                                    <td className='table-data-account bg-other-table'>{item.name}</td>
                                                    <td className='table-data-account bg-other-table'>
                                                        <button className="delete-btn-acc" onClick={() => handleDeleteTab(item.id)}>
                                                            <Icon icon="material-symbols:delete" />
                                                        </button>
                                                    </td>
                                                </tr>
                                            ))}
                                        </tbody>
                                    </table>
                                </div>
                            )}
                        </div>
                    </div>
                    <div className="ButtonTabSave">
                        {
                            itemId ? (
                                <button
                                    id="SaveBtnMain"
                                    className={`update-button-main-save hovered`}
                                    onClick={handleUpdate}
                                >
                                    Update
                                </button>
                            ) : (
                                <button
                                    id="SaveBtnMain"
                                    className={`save-button-main-save hovered`}
                                    onClick={handleSave}
                                >
                                    Save
                                </button>
                            )
                        }
                    </div>
                    <div className="company_info-text-im depart_top">Packages Details List</div>
                    <div className="control_radius">
                        <div className="table-account-manager">
                            <table className='table-master-acc'>
                                <thead className='header-table-account'>
                                    <tr>
                                        <th className='table-header-manager ac-sno-wth'>S.No</th>
                                        {/* <th className='table-header-manager'>Id</th> */}
                                        <th className='table-header-manager'>Package</th>
                                        <th className='table-header-manager'>Form</th>
                                        <th className='table-header-manager'> Creation Date</th>
                                        <th className='table-header-manager'>Actions</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {data1.map((item, idx) => (
                                        <tr key={item.id}>
                                            <td className='table-data-account ac-sno-wth'>{idx + 1}</td>
                                            {/* <td className='table-data-account'>{item.id}</td> */}
                                            <td className='table-data-account'>{getPackageName(item.packagesId)}</td>
                                            <td className='table-data-account'>{getFormName(item.formId)}</td>
                                            <td className='table-data-account'>{item.cr_dt}</td>
                                            <td className='table-data-account'>
                                                <button className="edit-btn-acc" onClick={() => handleEdit(item)}><Icon icon="lucide:edit" /></button>
                                                <button className="delete-btn-acc" onClick={() => handleDelete(item.id)}><Icon icon="material-symbols:delete" /></button>
                                            </td>
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default PackageDetails;
